import {UserAPI} from "../../api/api";

const SUCCESS_LOAD_DEVICES = 'mobileDevicesReducer/SUCCESS_LOAD_USERS'

const initialState = {
    devices: [],
    loading: true,
    error: null
}

export const mobileDevicesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUCCESS_LOAD_DEVICES:
            return {...state, devices: action.devices, loading: false}

        default:
            return state
    }
}

export const selectDevices = state => state.mobileDevicesReducer

export const successLoadDevices = devices => ({type: SUCCESS_LOAD_DEVICES, devices})

export const getDevices = async dispatch => {
    const response = await UserAPI.getUsers(true)

    if (response.status === 200) {
        const devices = response.data
        dispatch(successLoadDevices(devices))
    }
}

export const partialUpdateDevice = (params) => async () => {
    await UserAPI.patchUser(params.id, {[params.field]: params.value})
}